/**
 * Helpers: Classes
 * -----------------------------------------------------------------------------
 * - Standard CSS class names used to represent various UI states.
 */
export default {
  active: 'is-active',
  hidden: 'is-hidden',
  loading: 'is-loading',
  loaded: 'is-loaded',
  locked: 'is-locked',
  pending: 'is-pending',
  waiting: 'is-waiting',
  success: 'is-success',
  sticky: 'is-sticky',
}
